import { getSessionToken } from '../api/rest/utils';

const uploadToGoThumb = async (params) => {
  const { GOTHUMB_UPLOAD_URL } = window.MILO_CONFIG;
  return fetch(GOTHUMB_UPLOAD_URL, params).then((response) => response.text());
};

const fetchGoThumbSignedUrl = async (filename, sessionToken = null) => {
  if (!filename || filename === null || filename === '' || filename.toString() === '[object Object]') return null;

  const { API_URL } = window.MILO_CONFIG;

  const response = await fetch(`${API_URL}/gothumb/download/${filename}`, {
    method: 'GET',
    headers: {
      'session-token': sessionToken ? sessionToken : getSessionToken(),
      'source': 'WEB'
    },
  });

  const data = await response.json();

  /* Line 9 guards the filename going out; this guards what comes back. The
     endpoint answers {value: null} for a file that is missing or not yet
     processed, and most of the ~70 call sites use a bare .then() with no
     .catch(), so dereferencing null surfaced as an uncaught promise rejection.
     Returning null matches what this function already does for bad input. */
  if (!data || data.value === null || data.value === undefined) return null;

  return data.value.toString();
};

export { uploadToGoThumb, fetchGoThumbSignedUrl };
